import React, { useState, useEffect } from 'react'
import { Form, Input, Button, message } from 'antd'
import bxlutils from 'bxl-utils'
import legoService from '@services/lego'
import { Base64 } from 'js-base64'
const FormItem = Form.Item

const ArticleDetail = props => {
  const [articleId, setarticleId] = useState('')
  const [link, setlink] = useState('')
  const { setParams } = props
  const changeText = e => {
    setarticleId(e.target.value.trim())
  }
  const copy = link => {
    if (!link) {
      return message.error('请先确认文章Id')
    }
    const input = document.createElement('input')
    input.value = link
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    message.success('复制成功！')
  }
  const loadArticle = () => {
    legoService.getArticleDetail(articleId).then(res => {
      let deeplink = ''
      let fullLink = false
      //短手文章
      if (res.data.dynamicLink && res.data.dynamicLink.length > 0) {
        deeplink = res.data.dynamicLink
        if (deeplink.startsWith('bieyang:')) {
          // deeplink
          let normalLink: any = res.data.dynamicLink.split('link=')[1] || ''
          try {
            normalLink = decodeURIComponent(normalLink.replace('&_cc=300', ''))
            normalLink = Base64.decode(normalLink)
          } catch (e) {
            console.log(e)
          }
          if (normalLink) {
            setlink(normalLink)
          }
          fullLink = true
        } else {
          // 普通link
          setlink(deeplink)
          fullLink = false
        }
      } else {
        fullLink = false
        //普通文章，跳转h5 article页面
        deeplink = bxlutils.uri.encodeBase64(
          `https://baleen-cdn-g.bybieyang.com/article-detail/index.html?articleId=${articleId}`
        )
        setlink(
          `https://baleen-cdn-g.bybieyang.com/article-detail/index.html?articleId=${articleId}`
        )
      }
      setParams(
        {
          link: deeplink,
          fullLink,
        },
        'wvp'
      )
    })
  }
  useEffect(() => {
    if (articleId) bxlutils.throttle(500, loadArticle())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleId])
  return (
    <>
      <FormItem label="articleId">
        <Input onChange={changeText}></Input>
      </FormItem>
      <FormItem label="normal link" style={{ display: 'flex' }}>
        <Input value={link} disabled></Input>
        <Button style={{ marginLeft: 10 }} type="link" onClick={() => copy(link)}>
          copy
        </Button>
      </FormItem>
    </>
  )
}

export default ArticleDetail
